import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { PcpReferralEngagementView } from '../components/views/pcpReferralEngagementView'
import { Page, PageHeader } from '../ui'

function PcpReferralEngagement() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="PCP Referral"
                        title="PCP Referral Engagement"
                        intro="Search for a PCP Referral client, complete their email and date of birth, then send a CFA e-sign link by email or SMS."
                    />
                    <PcpReferralEngagementView />
                </Page>
            </MainView>
        </div>
    )
}

export default PcpReferralEngagement
